import { useQuery } from '@tanstack/react-query';
import { apiAxios } from '@/lib/apiAxios';
const fetchSystemTemplates = async () => {
    const response = await apiAxios.get('/campaign-templates');
    return response.data.map((t) => ({ ...t, source: 'system' }));
};
export const useSystemTemplates = () => useQuery({
    queryKey: ['campaign-templates'],
    queryFn: fetchSystemTemplates,
    // System templates ship with the codebase — they can't change at
    // runtime, so we cache aggressively. A redeploy flushes the SPA
    // cache anyway.
    staleTime: Infinity,
});
const fetchWorkspaceTemplates = async (workspaceId) => apiAxios
    .get(`/workspaces/${workspaceId}/campaign-templates`)
    .then((response) => response.data);
export const useWorkspaceTemplates = (workspaceId) => useQuery({
    queryKey: ['campaign-templates', 'workspace', workspaceId],
    queryFn: () => fetchWorkspaceTemplates(workspaceId),
    enabled: Boolean(workspaceId),
    staleTime: 60_000,
});
/**
 * Map a workspace-template DTO to the unified CampaignTemplate shape used by
 * the gallery. Industry tags are empty (workspace templates aren't tagged);
 * proOnly is false (the user already has Pro to create them).
 */
export const mapWorkspaceTemplate = (t) => {
    const tagline = t.defaults && typeof t.defaults === 'object' && t.defaults.campaign
        ? t.defaults.campaign.showroomTagline
        : undefined;
    const feedbackTitle = t.defaults && typeof t.defaults === 'object' && t.defaults.campaign
        ? t.defaults.campaign.feedbackTitle
        : undefined;
    const feedbackThankYou = t.defaults && typeof t.defaults === 'object' && t.defaults.campaign
        ? t.defaults.campaign.feedbackThankYouMessage
        : undefined;
    return {
        id: t.publicId,
        source: 'workspace',
        industryTags: [],
        mode: t.mode,
        proOnly: false,
        previewImage: t.previewImageUrl,
        name: t.name,
        description: t.description ?? '',
        tagline: typeof tagline === 'string' ? tagline : '',
        feedbackTitle: typeof feedbackTitle === 'string' ? feedbackTitle : null,
        feedbackThankYouMessage: typeof feedbackThankYou === 'string' ? feedbackThankYou : null,
        defaults: t.defaults,
    };
};
